import Page from "@/lib/pages/Page";
import {Modal, StyleSheet, useWindowDimensions, View} from "react-native";
import {Image} from "expo-image";
import {BASE_URL} from "@/lib/constants";
import {Gallery, GalleryRefType} from "react-native-zoom-toolkit";
import {useCallback, useEffect, useRef} from "react";

type Props = {
    thumbnailId: string | null,
    thumbnails: string[],
    onThumbnailClick: (thumbnail: string | null) => any,
}

export default function Carousel({thumbnailId, thumbnails, onThumbnailClick}: Props) {
    const galleryRef = useRef<GalleryRefType>(null);

    const dimensions = useWindowDimensions();

    const renderItem = useCallback((item: string, index: number) => {
        // console.log(item, index, dimensions);
        return <Image
            source={item}
            contentFit={'contain'}
            style={{
                width: dimensions.width,
                // height: dimensions.height,
                height: "100%",
            }}
        />
    }, [dimensions]);

    useEffect(() => {
        const index = thumbnails.findIndex(t => t === thumbnailId);
        if (index === -1 || !galleryRef.current) {
            return;
        }
        galleryRef.current.setIndex(index);
        galleryRef.current.reset(false);
    }, [thumbnailId, thumbnails, galleryRef]);

    const keypressHandler = useCallback((ev: KeyboardEvent) => {
        let index = thumbnails.findIndex(t => t === thumbnailId);
        if (index === -1 || !galleryRef.current) {
            return;
        }
        switch (ev.key) {
            case "ArrowRight":
                index++;
                break;
            case "ArrowLeft":
                index--;
                if (index < 0) {
                    index += thumbnails.length;
                }
                break;
            default:
                return;
        }
        index %= thumbnails.length;
        const newId = thumbnails.at(index);
        if (newId === undefined) {
            return;
        }
        // console.debug(`Switch to thumbnail ${index}/${thumbnails.length - 1}`, newId);
        onThumbnailClick(newId);
    }, [thumbnails, thumbnailId, galleryRef, onThumbnailClick]);

    useEffect(() => {
        if (!window || !window.addEventListener) {
            return;
        }
        window.addEventListener('keydown', keypressHandler);
        return () => {
            window.removeEventListener('keydown', keypressHandler);
        };
    }, [keypressHandler]);

    const dismiss = () => onThumbnailClick(null);

    return (
        <Modal
            visible={thumbnailId !== null}
            allowSwipeDismissal={true}
            onDismiss={dismiss}
            onRequestClose={dismiss}
            animationType={"slide"}
            presentationStyle={"fullScreen"}
        >
            <Page>
                <View style={styles.imageContainer}>
                    <Gallery
                        ref={galleryRef}
                        data={thumbnails.map(thumbnailURL)}
                        renderItem={renderItem}
                        allowPinchPanning={true}
                        onSwipe={direction => {
                            if (direction === "down") {
                                dismiss();
                            }
                        }}
                        onTap={dismiss}
                    />
                </View>
            </Page>
        </Modal>
    )
}

function thumbnailURL(thumbnailID: string | null | undefined): string {
    return !!thumbnailID ? BASE_URL + `/f/originals/${thumbnailID}.webp` : "";
}

export const styles = StyleSheet.create({
    imageContainer: {
        flex: 1,
        borderRadius: 8,
    },
})